import { PropsWithChildren, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import classNames from 'classnames'

export default function Container ({ children, className }: PropsWithChildren<{ className?: string }>): ReactNode {
  return (
    <div className={twMerge(classNames('mx-auto container frame:max-w-[100%] px-4 frame:px-0 xl:max-w-[1184px]', className))}>{children}</div>
  )
}
